/**
 * Date formatting utilities for tenant onboarding
 */

/**
 * Format Date to DD/MM/YYYY string
 */
export function formatDateToDDMMYYYY(date: Date | null): string {
  if (!date) return "";
  const day = String(date.getUTCDate()).padStart(2, "0");
  const month = String(date.getUTCMonth() + 1).padStart(2, "0");
  const year = date.getUTCFullYear();
  return `${day}/${month}/${year}`;
}

/**
 * Parse DD/MM/YYYY string to Date object
 */
export function parseDDMMYYYY(dateString: string): Date {
  const parts = dateString.split("/");
  if (parts.length !== 3) {
    throw new Error("Date must be in DD/MM/YYYY format");
  }
  const day = parseInt(parts[0], 10);
  const month = parseInt(parts[1], 10) - 1; // Month is 0-indexed
  const year = parseInt(parts[2], 10);

  if (isNaN(day) || isNaN(month) || isNaN(year)) {
    throw new Error("Date must contain valid numbers");
  }

  if (month < 0 || month > 11) {
    throw new Error("Month must be between 01 and 12");
  }

  if (day < 1 || day > 31) {
    throw new Error("Day must be between 01 and 31");
  }

  if (year < 1900 || year > 2100) {
    throw new Error("Year must be between 1900 and 2100");
  }

  // Create date in UTC at midday (12:00:00.000)
  const date = new Date(Date.UTC(year, month, day, 12, 0, 0, 0));

  if (isNaN(date.getTime())) {
    throw new Error(`Invalid date: ${dateString}`);
  }

  // Verify the date components match (in UTC)
  const utcDay = date.getUTCDate();
  const utcMonth = date.getUTCMonth();
  const utcYear = date.getUTCFullYear();

  if (utcDay !== day || utcMonth !== month || utcYear !== year) {
    throw new Error(`Invalid date: ${dateString}`);
  }

  return date;
}

/**
 * Validate that end date is after start date
 */
export function validateDateRange(
  startDate: Date | null,
  endDate: Date | null,
): boolean {
  if (!startDate || !endDate) return true;
  return endDate > startDate;
}
